import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ecad978"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mobile-menu-toggle-wrapper" }
const _hoisted_2 = {
  "scroll-region": "",
  class: "main-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_TextButton = _resolveComponent("TextButton")!
  const _component_Nav = _resolveComponent("Nav")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["layout", _ctx.layoutClasses])
  }, [
    _createElementVNode("aside", {
      class: _normalizeClass(["nav-wrapper", _ctx.navClasses]),
      style: {"z-index":"10"}
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_TextButton, {
          color: _ctx.navOpen ? 'white' : 'black',
          class: "mobile-menu-toggle",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navOpen = !_ctx.navOpen))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_SvgIcon, {
              type: "mdi",
              path: _ctx.menuIcon
            }, null, 8, ["path"])
          ]),
          _: 1
        }, 8, ["color"])
      ]),
      _createVNode(_component_Nav, {
        isSmall: _ctx.navIsSmall,
        class: "nav"
      }, null, 8, ["isSmall"])
    ], 2),
    _createElementVNode("main", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])
  ], 2))
}